import axios from 'axios';
import store from '@store';
import { getLocal, setLocal } from '@utils/storage';

const getAuthHeaders = () => {
  const user = store.getState().auth.user;
  return {
    'X-FNOTRADER-SECRET': user?.loginSecret ?? '',
    'X-FNOTRADER-USERID': user?.userID ?? '',
  };
};

const handleError = (e) => {
  if (import.meta.env.DEV) console.error('[API Error]', e);

  if (e?.response) {
    return {
      code: e.response.code,
      error: e.response.error || 'API Error',
      ...e.response.data,
    };
  }

  return {
    code: 0,
    error: 'Network error. Please try again.',
  };
};

const createInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: { 'Content-Type': 'application/json' },
    paramsSerializer: (params) => {
      return Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&');
    },
  });

  instance.interceptors.request.use((config) => {
    const headers = getAuthHeaders();
    if (headers['X-FNOTRADER-SECRET']) {
      config.headers['X-FNOTRADER-SECRET'] = headers['X-FNOTRADER-SECRET'];
      config.headers['X-FNOTRADER-USERID'] = headers['X-FNOTRADER-USERID'];
    }
    return config;
  });

  instance.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        const theme = getLocal('app-theme');
        localStorage.clear();
        if (theme) setLocal('app-theme', theme);
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

const tradeClient = createInstance(import.meta.env.VITE_API_URL_TRADE);
const stockClient = createInstance(import.meta.env.VITE_API_URL_STOCK);

export const tradeApi = {
  get: (url, config) => tradeClient.get(url, config).then(r => r.data).catch(handleError),
  post: (url, data, config) => tradeClient.post(url, data, config).then(r => r.data).catch(handleError),
  put: (url, data, config) => tradeClient.put(url, data, config).then(r => r.data).catch(handleError),
  delete: (url, config) => tradeClient.delete(url, config).then(r => r.data).catch(handleError),
};

export const stockApi = {
  get: (url, config) => stockClient.get(url, config).then(r => r.data).catch(handleError),
  post: (url, data, config) => stockClient.post(url, data, config).then(r => r.data).catch(handleError),
  put: (url, data, config) => stockClient.put(url, data, config).then(r => r.data).catch(handleError),
  delete: (url, config) => stockClient.delete(url, config).then(r => r.data).catch(handleError),
};